import { APP_CLEAR_CURRENT_USER } from '../actions/app.actions'
import * as Actions from '../actions/dashboard.actions'

const initialState = []

export default (state = initialState, action) => {
  switch (action.type) {
    case Actions.CAMPAIGNS_BUDGET:
      return [...state, action.campaignsbudget]
    case Actions.CAMPAIGNS_BUDGET_CLEAR:
      return []
    case APP_CLEAR_CURRENT_USER:
      return initialState
    default:
      return state
  }
}